<template>
  <el-dialog title="Add Promotion Code" :width="dialogWidth" :visible.sync="visible" :close-on-click-modal="false">
    <div v-loading="form_loading">
      <div class="form">
        <div class="div">
          Type*
          <el-select class="margin-top-switch" v-model="model_obj.type" placeholder="Select Type">
            <el-option label="New Client" :value="0"></el-option>
            <el-option label="Discount" :value="1"></el-option>
          </el-select>
        </div>
        <div class="div" v-if="model_obj.type == 0">
          Add Days(DAY)*
          <el-input-number :precision="0" :controls="false" class="margin-top-switch width100" placeholder="Please enter days" v-model="model_obj.addTime" :min="1" :max="99999"/>
        </div>
        <div class="div" v-if="model_obj.type == 1">
          Discount Amounts($)*
          <el-input-number :precision="2" :controls="false" class="margin-top-switch width100" placeholder="Please enter discount amounts" v-model="model_obj.discountMoney" :min="0.01" :max="99999999"/>
        </div>
        <div class="div">
          Belongs To
          <el-select class="margin-top-switch" v-model="model_obj.belongsId" placeholder="Select Type">
            <el-option :label="item.email + '(' + item.practiceName + ')'" :value="item.id" v-for="(item,index) of subList" :key="index"></el-option>
          </el-select>
        </div>
        <div class="div">
          Period Validity*
          <el-date-picker
            v-model="model_obj.time_range"
            class="margin-top-switch width100"
            type="daterange"
            :clearable="false"
            format="MM/dd/yyyy"
            value-format="yyyy-MM-dd"
            placement="bottom-start"
            start-placeholder="Start Time"
            end-placeholder="End Time">
          </el-date-picker>
        </div>

        <div class="div">
          Description
          <el-input
            class="margin-top-switch"
            type="textarea"
            :rows="4"
            placeholder="Please enter description"
            resize="none"
            v-model="model_obj.description">
          </el-input>
        </div>

      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="save_model" icon="el-icon-check" size="small" style="background-color: #034844;border-color:#034844;">Save</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Vue from 'vue';
import { getAction,putAction } from '@/network/manage';

export default {
  name: 'editPromotionCode',
  components: {},
  data() {
    return {
      dialogWidth:'600px',
      visible: false,
      model_obj: {},
      form_loading: false,
      subList: [],
      id: undefined
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.setDialogWidth()
      })()
    }
  },
  created() {
  },
  methods: {
    async init_sub_list() {
      let res = await getAction("/admin/accountManagement/subList")
      this.subList = res.result
    },
    async init(id) {
      this.id = id
      this.visible = true
      this.model_obj = {description:""}
      let res = await getAction("/admin/promotion/queryById?id=" + id)
      this.model_obj = res.result
      if(this.model_obj.type == 0) {
        this.model_obj.discountMoney = undefined
      } else {
        this.model_obj.addTime = undefined
      }
      let times = [res.result.startTime, res.result.endTime]
      this.model_obj.time_range = times
      this.init_sub_list()
    },
    save_model() {
      if(!this.model_obj.type && (this.model_obj.type != 0)) {
        this.$message({
          message: 'Please select type.',
          type: 'warning'
        });
        return;
      }
      if(this.model_obj.type == 0 &&
      (this.model_obj.addTime == null
      || this.model_obj.addTime == undefined)) {
        this.$message({
          message: 'Please enter add days.',
          type: 'warning'
        });
        return;
      }
      if(this.model_obj.type == 1 &&
      (this.model_obj.discountMoney == null
      || this.model_obj.discountMoney == undefined)) {
        this.$message({
          message: 'Please enter discount amounts.',
          type: 'warning'
        });
        return;
      }
      if(!this.model_obj.time_range
      || this.model_obj.time_range.length == 0) {
        this.$message({
          message: 'Please enter period validity.',
          type: 'warning'
        });
        return;
      }
      this.model_obj.startTime = this.model_obj.time_range[0]
      this.model_obj.endTime = this.model_obj.time_range[1]
      if(this.model_obj.type == 0) {
        delete this.model_obj.discountMoney
      } else {
        delete this.model_obj.addTime
      }
      this.form_loading = true
      putAction("/admin/promotion/edit/" + this.id, this.model_obj).then((res) => {
        if(res.code == 200) {
            this.$emit('ok')
            this.$message({
              type: 'success',
              message: 'edit success!'
            });
            this.visible = false
        } else {
            this.$message.error({message: res.message});
        }
      }).catch((err) => {
        this.$message.error({message: err.response.data.details.data.message});
      }).finally((res) => {
        this.form_loading = false
      })
    },
    setDialogWidth() {
      var val = document.body.clientWidth
      const def = 600 // default width
      if (val < def) {
        this.dialogWidth = '98%'
      } else {
        this.dialogWidth = def + 'px'
      }
    }
  }
}
</script>

<style scoped>
  .form{display: flex;flex-direction: column;}
  .form .flex{display: grid;grid-template-columns:1fr 1fr;gap: 20px;padding-bottom: 0;}
  .form .div{display: flex;flex-direction: column;color:#A0ABC0;font-weight: bold;padding-bottom:20px;}
  .form .div input{border-radius: 6px;border:1px solid #E2E8F0;height:40px;padding:0 20px;margin-top:10px;}
  .form .div select{border-radius: 6px;border:1px solid #E2E8F0;height:40px;padding:0 20px;margin-top:10px;box-sizing: border-box;}
  .headImage{display: flex;width: 76px;margin-top:15px;}
  .headImage .edit{display: none;padding-bottom:0;width: 76px;height: 76px;position: absolute;justify-content: center;align-items: center;background-color: rgba(0, 0, 0, 0.5);border-radius: 4px;}
  .headImage .edit span{background-color: rgba(255, 255, 255, 0.36);margin-left:0;padding:4px 10px;border-radius:4px;font-weight: bold;color:#ffffff;cursor: pointer;}
  .headImage:hover .edit{display: flex;}
  .headImage img{width: 76px;height: 76px;border-radius: 4px;}
  .default_upload {width: 76px;height: 76px;border: 1px dashed #d9d9d9;border-radius: 6px;cursor: pointer;display: flex;align-items: center;justify-content: center;}
  .avatar-uploader-icon {font-size: 18px;color: #8c939d;}
  .font-size-16 {font-size: 16px;}
  .margin-top-switch {margin-top: 10px;}
  .width100 {width:100%;}
  .marginbottom15 {margin-bottom: 15px;}
  .have_btn {display: flex;justify-content:center;align-items: center;padding-bottom:10px;font-weight: bold;color:#A0ABC0;}
  .card_header {display: flex;justify-content:flex-end;align-items: center;}
  .el-icon-circle-close:hover {color: red;cursor: pointer;}
  .el-icon-sort-down:hover {color: red;cursor: pointer;}
  .el-icon-sort-up:hover {color: red;cursor: pointer;}
  .dialog-footer {display: flex;justify-content: flex-end;}
</style>
<style>
  .el-input-number .el-input__inner {text-align: left !important;}
</style>
